/** Institutos que podem ser parametrizados. Hoje só o resgate tem parametrização. */
export enum TipoInstituto {
  Resgate = 'Resgate',
  Portabilidade = 'Portabilidade',
  BeneficioProporcionalDiferido = 'BeneficioProporcionalDiferido',
  Autopatrocinio = 'Autopatrocinio',
}
